import React from 'react';

export const Footer = () => (
    <footer>
        <a href={window.env.LINK_SUPPORT ? window.env.LINK_SUPPORT : '/support'}>Contact Support</a>
    </footer>
)
